var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNewHireOnboarding = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "#DADADA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2187.5,
    y: -605.5,
    width: 2930,
    height: 1355,
    stroke: "black",
    strokeWidth: 11
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 957,
    transform: "translate(-20 -367)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7692 7.19229C12.7434 7.19229 13.6458 7.4996 14.3846 8.01614V5.23076C14.3846 4.50499 13.8027 3.92306 13.0769 3.92306H10.4615V2.61537C10.4615 1.8896 9.8796 1.30768 9.15383 1.30768H6.53845C5.81268 1.30768 5.23076 1.8896 5.23076 2.61537V3.92306H2.61537C1.8896 3.92306 1.31422 4.50499 1.31422 5.23076L1.30768 12.4231C1.30768 13.1488 1.8896 13.7308 2.61537 13.7308H7.63691C7.30518 13.0334 7.1554 12.2635 7.20154 11.4927C7.24768 10.7218 7.48824 9.97525 7.90078 9.32248C8.31333 8.66972 8.88444 8.13204 9.56086 7.75956C10.2373 7.38707 10.997 7.19192 11.7692 7.19229V7.19229ZM6.53845 2.61537H9.15383V3.92306H6.53845V2.61537Z",
    fill: "#7D7DF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0962 8.5C10.1133 8.5 8.5 10.1131 8.5 12.096C8.5 14.0788 10.1134 15.6921 12.0962 15.6921C14.0792 15.6921 15.6923 14.0787 15.6923 12.0958C15.6923 10.1129 14.0792 8.5 12.0962 8.5Z",
    fill: "#7D7DF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3521 10.3905C12.3521 10.3226 12.3252 10.2576 12.2772 10.2096C12.2292 10.1616 12.1641 10.1346 12.0963 10.1346C12.0284 10.1346 11.9633 10.1616 11.9154 10.2096C11.8674 10.2576 11.8404 10.3226 11.8404 10.3905V11.8403H10.3906C10.3227 11.8403 10.2577 11.8673 10.2097 11.9153C10.1617 11.9632 10.1347 12.0283 10.1347 12.0962C10.1347 12.164 10.1617 12.2291 10.2097 12.2771C10.2577 12.3251 10.3227 12.352 10.3906 12.352H11.8404V13.8019C11.8404 13.8697 11.8674 13.9348 11.9154 13.9828C11.9633 14.0308 12.0284 14.0577 12.0963 14.0577C12.1641 14.0577 12.2292 14.0308 12.2772 13.9828C12.3252 13.9348 12.3521 13.8697 12.3521 13.8019V12.352H13.802C13.8698 12.352 13.9349 12.3251 13.9829 12.2771C14.0309 12.2291 14.0578 12.164 14.0578 12.0962C14.0578 12.0283 14.0309 11.9632 13.9829 11.9153C13.9349 11.8673 13.8698 11.8403 13.802 11.8403H12.3521V10.3905Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewHireOnboarding, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-hire-onboarding.3b19bbf9.svg";
export { ForwardRef as ReactComponent };